<template>
  <div>
    <va-modal
      class="modal"
      v-model="showModal"
      max-width="100%"
      :okText="linkList.length > 0 ? 'Fermer' : 'Sauvegarder'"
      cancelText="Annuler"
      v-on:cancel="closeModal"
      v-on:ok="saveLink"
      title="Entreprise liées"
    >
      <div class="row row-inside forcewidth-link">
        <div class="flex md12" v-if="listEntreprise.length > 0">
          <va-select
            :options="listEntreprise"
            v-model="linkEntreprise"
            textBy="nom"
            keyBy="identreprise"
            searchable
            label="Entreprise à lier"
          />
        </div>
        <div class="flex md12" v-if="linkList.length > 0">
          <p v-for="(entreprise, index) in linkList">{{ entreprise.nom }}</p>
          </br>
          <va-button outline color="danger" @click="deleteLink"
            >Supprimer le lien</va-button
          >
        </div>
        <div class="flex md12"></div>
        <div class="flex md12">
          <h4>Status du plan de relance</h4>
          <div class="row row-inside">
            <div class="flex md5">
     <va-toggle
            small
            v-model="noRelance"
            label="Retirer du plan de relance"
          />
            </div>
            <div class="flex md6" v-show="noRelance!==noRelanceOld && linkList.length > 0">
               <va-button outline color="success" @click="changeNRstatus"
            >Sauvegarder</va-button
          >
            </div>
          </div>

        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "adhesions_liees",
  props: ["value", "identreprise"],
  data() {
    return {
      showModal: false,
      linkList: [],
      listEntreprise: [],
      linkEntreprise: "",
      noRelance: false,
      firstChange: false,
      noRelanceOld: false,
    };
  },
  methods: {
    async changeNRstatus() {
      try {
        let results = await axios.put("/api/liees/norelance", {
          identreprise: this.identreprise,
          campagne_norelance: this.noRelance,
        });

        console.log(results.data);
        this.noRelance = !!results.data.campagne_norelance_lies;
        this.noRelanceOld = this.noRelance;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteLink() {
      try {
        await axios.delete("/api/liees/link", {
          params: { identreprise: this.identreprise },
        });
        this.closeModal();
      } catch (error) {
        console.log(error);
      }
    },
    async saveLink() {
      // save new link
      // prevent close before end of process
      this.showModal = true;
      try {
        // check that info match
        if (this.linkList.length > 0) {
          this.closeModal();
        }
        if (
          this.linkEntreprise &&
          this.identreprise &&
          this.linkList.length === 0
        ) {
          console.log("link entreprise", this.linkEntreprise);
          await axios.put("/api/liees/link", {
            identreprise: this.identreprise,
            identreprise_main: this.linkEntreprise.identreprise,
            campagne_norelance: this.noRelance,
          });
          this.$emit("updateList");
          this.closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadListEntreprise() {
      try {
        let results = await axios.get("/api/liees/list-entreprises", {
          params: { identreprise: this.identreprise },
        });

        this.listEntreprise = results.data;
      } catch (error) {
        console.log(error);
      }
    },
    async loadList() {
      try {
        let results = await axios.get("/api/liees/list", {
          params: { identreprise: this.identreprise },
        });
        this.linkList = results.data.list;
        this.noRelance = results.data.noRelance;
        this.noRelanceOld = results.data.noRelance;

        if (this.linkList.length === 0 && this.listEntreprise.length === 0) {
          this.loadListEntreprise();
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.resetComponent();
      this.showModal = false;
      this.$emit("input", false);
    },
    resetComponent() {
      this.linkList = [];
      this.listEntreprise = [];
      this.linkEntreprise = "";
      this.noRelance = false;
      this.firstChange = false;
    },
  },
  watch: {
    value() {
      console.log("test");
      this.showModal = this.value;
      // Parent property changed; update internal variables
      if (!this.value) {
        this.resetComponent();
      } else if (!this.identreprise) {
        // TODO error no identreprise
        console.log("no identreprise");
      } else {
        this.loadList();
      }
    },
  },
};
</script>

<style lang="scss">
.forcewidth-link {
  width: 35vw;
  height: 40vh;
  overflow: auto;
}
</style>
